import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { lazyComponent } from '../../common/utils';

const Home = lazyComponent('Home', import('../../pages/Home/Home'));
const Apps = lazyComponent('Apps', import('../../pages/Apps/Apps'));
const AppOverview = lazyComponent('AppDetails', import('../../pages/Apps/AppDetails'));
const AppCustomers = lazyComponent('AppCustomer', import('../../pages/Apps/AppCustomers'));
const AppServices = lazyComponent('AppServices', import('../../pages/Apps/AppServices'));
const AppProducts = lazyComponent('AppProducts', import('../../pages/Apps/AppProducts'));
const Banks = lazyComponent('Banks', import('../../pages/Banks/Banks'));
const ServiceInfo = lazyComponent('ServiceDetails', import('../../pages/Apps/ServiceDetails'));
const Customer = lazyComponent('Customer', import('../../pages/Customer/Customer'));
const CustomerDetails = lazyComponent(
  'CustomerDetails',
  import('../../pages/Customer/CustomerDetails')
);
const BankDetails = lazyComponent('BankDetails', import('../../pages/Banks/BankDetails'));
const Product = lazyComponent('Product', import('../../pages/Products/Product'));
const Monitoring = lazyComponent('Monitoring', import('../../pages/Monitoring/Monitoring'));
const TransactionRequest = lazyComponent(
  'TransactionRequest',
  import('../../pages/Monitoring/TransactionRequest')
);
const Transaction = lazyComponent('Transaction', import('../../pages/Monitoring/Transactions'));
const ActivityLog = lazyComponent('ActivityLog', import('../../pages/Monitoring/ActivityLog'));
const Admin = lazyComponent('Admin', import('../../pages/Settings/Settings'));
const Roles = lazyComponent('Roles', import('../../pages/Settings/Roles'));
const Permissions = lazyComponent('RoleDetails', import('../../pages/Settings/Permissions'));
const SystemInfo = lazyComponent('SystemInfo', import('../../pages/Settings/System'));
const PageNotFound = lazyComponent('PageNotFound', import('../../pages/PageNotFound/PageNotFound'));

export const Routes: FC = () => (
  <Switch>
    <Route component={Home} exact path="/home" />
    <Route component={Apps} exact path="/apps" />
    <Route component={AppServices} exact path="/app/:uid/service" />
    <Route component={ServiceInfo} exact path="/app/:appid/service/:uid" />
    <Route component={AppProducts} exact path="/app/:uid/products" />
    <Route component={AppCustomers} exact path="/app/:uid/accounts" />
    <Route component={Monitoring} exact path="/app/:appid/monitoring" />
    <Route component={Monitoring} exact path="/app/:appid/transaction-requests" />
    <Route component={TransactionRequest} exact path="/app/:appid/transaction-requests/:uid" />
    <Route component={Transaction} exact path="/app/:appid/transactions" />
    <Route component={AppOverview} path="/app/:uid" />
    <Route component={Banks} exact path="/bank" />
    <Route component={BankDetails} exact path="/bank/:uid" />
    <Route component={Product} exact path="/product" />
    <Route component={Customer} exact path="/accounts" />
    <Route component={CustomerDetails} exact path="/account/:uid" />
    <Route component={TransactionRequest} exact path="/monitoring/transaction-request/:uid" />
    <Route component={Transaction} exact path="/monitoring/transactions" />
    <Route component={ActivityLog} exact path="/monitoring/activity-log" />
    <Route component={Monitoring} path="/monitoring" />
    <Route component={Admin} exact path="/settings/admin" />
    <Route component={Roles} exact path="/settings/roles" />
    <Route component={Permissions} exact path="/settings/roles/:uid" />
    <Route component={SystemInfo} exact path="/settings/system" />
    <Route component={Admin} path="/settings/" />
    <Route component={Home} exact path="/" />
    <Route component={PageNotFound} />
  </Switch>
);
